'use strict';


var createjs = createjs || {};

createjs.BaseTransform = class {
	constructor(element){
		this.el = element;

		this.debug = false;

		this._tween = null;

		this.lock = false;

		this.useTween = false;

		_.bindAll(this, 'enable', 'disable', 'destroy', '_startTransform', '_update', '_stopTransform');

		if(this.el) this.enable();
	}

	enable() {
		this.el.on('start', this._startTransform);
		this.el.on('update', this._update);
		this.el.on('pressup', this._stopTransform);
		this.lock = false;

		return this;
	}

	disable() {
		this.el.off('start', this._startTransform);
		this.el.off('update', this._update);
		this.el.off('pressup', this._stopTransform);
		this.lock = true;

		return this;

	}

	destroy() {
		this.disable();
		this.el = null;

		return this;

	}

	_stopTween(){
		if (this._tween) {
			this._tween.kill();
			this._tween = null;
		}
	};

	_startTransform(evt) {
	}

	_update(evt) {
	}

	_stopTransform(evt) {
	}
};